'use client';

import React, { createContext, useContext, ReactNode } from 'react';
import { Tag } from '@/types/tags';

interface TagPrefetchContextValue {
    prefetchedTags: Record<string, Tag>;
}

const TagPrefetchContext = createContext<TagPrefetchContextValue>({ prefetchedTags: {} });

export function useTagPrefetch() {
    return useContext(TagPrefetchContext);
}

interface TagPrefetchProviderProps {
    prefetchedTags: Record<string, Tag>;
    children: ReactNode;
}

/**
 * Provider for server-prefetched tag data
 * Wraps page content to provide tag data for hydration
 */
export function TagPrefetchProvider({ prefetchedTags, children }: TagPrefetchProviderProps) {
    return (
        <TagPrefetchContext.Provider value={{ prefetchedTags }}>
            {children}
        </TagPrefetchContext.Provider>
    );
}
